<script setup>
import { defineAsyncComponent, onMounted, reactive } from 'vue'

const CmsBlock = defineAsyncComponent(
  () => import('@/components/basic/atoms/CmsBlock.vue')
)

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const { default: ApiController } = await import('@/services/ApiController')

    cache = { ApiController }

    return cache
  }
})()

const state = reactive({
  navigationItems: []
})

const extractPath = (url) => {
  if (!url || url.startsWith('/')) {
    return url
  }

  try {
    const urlObj = new URL(url)
    return urlObj.pathname + urlObj.hash + urlObj.search
  } catch {
    return url
  }
}

onMounted(async () => {
  const { ApiController } = await _getModules()
  const navigationItems = await ApiController.fetchNavigation()

  state.navigationItems = Array.isArray(navigationItems)
    ? navigationItems.map((item) => ({
        ...item,
        url: extractPath(item.url)
      }))
    : []
})
</script>

<template>
  <div
    id="main-navigation"
    class="d-flex justify-center font-size-m"
    :style="{
      backgroundColor: `rgb(var(--v-theme-white))`,
      borderTop: `1px solid rgb(var(--v-theme-light-ochre))`,
      borderBottom: `1px solid rgb(var(--v-theme-light-ochre))`
    }"
  >
    <div class="v-container pa-0">
      <div class="d-flex w-100 justify-center">
        <VBtn
          v-for="(navigationItem, index) in state.navigationItems"
          :key="navigationItem.name"
          :class="navigationItem.css_classes"
          variant="text"
          :color="navigationItem.link_color || 'secondary'"
          min-width="50px"
          flex-shrink="1"
          :to="
            $vuetify.display.platform.touch && navigationItem.flyout
              ? null
              : navigationItem.url
          "
          :append-icon="navigationItem.flyout ? 'custom:down' : ''"
        >
          {{ navigationItem.name }}
          <VMenu
            v-if="navigationItem.flyout"
            activator="parent"
            transition="slide-y-transition"
            bottom
            scroll-strategy="none"
            :open-on-hover="!$vuetify.display.platform.touch"
            target="#main-navigation > .v-container"
          >
            <VCard class="pa-3">
              <VContainer>
                <CmsBlock :blockData="navigationItem.flyout" />
              </VContainer>
            </VCard>
          </VMenu>
        </VBtn>
      </div>
    </div>
  </div>
</template>

<style scoped>
#main-navigation {
  min-height: 56px;
}

#main-navigation .v-btn {
  flex-shrink: 1;
}

#main-navigation :deep(.v-btn__content) {
  white-space: normal;
}

:deep(.flyout) {
  li.headline {
    margin: 0 10px 10px 10px;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 2px solid rgb(var(--v-theme-light-ochre));
    padding: 0.5rem 0;
    letter-spacing: 0.5px;
  }

  a {
    letter-spacing: 0.5px;
  }
}
</style>
